import { render } from "./CashRegisterTicket.vue?vue&type=template&id=6d99ba0c&scoped=true"
import script from "./CashRegisterTicket.vue?vue&type=script&lang=js"
export * from "./CashRegisterTicket.vue?vue&type=script&lang=js"

import "./CashRegisterTicket.vue?vue&type=style&index=0&id=6d99ba0c&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d99ba0c"]])

export default __exports__